import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  IconButton,
  Grid,
  Paper,
  Divider,
  Container,
} from "@mui/material";
import { Card, Input, notification, Select } from "antd";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import {
  AmexIcon,
  MasterCardIcon,
  MinusIcon,
  PaymentBackIcon,
  PaypalIcon,
  PlusIcon,
  StripeIcon,
  VisaIcon,
} from "../../Svg/icons";
import { AllTypoFontStyles } from "../../Styles/styles";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { useLocation, useNavigate } from "react-router-dom";
import PaymentForm from "./PaymentForm";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import {
  useBookEventMutation,
  useGetProfileInformationQuery,
  useIdentifyTaxMutation,
} from "../../Redux/apis/ApiSlice";
import { useSelector } from "react-redux";

const { Option } = Select;

const TicketBooking = () => {
  const location = useLocation();
  const { event, ticketSummary, invitationId } = location.state || {};
  const [quantities, setQuantities] = useState({});
  const [identifyTax, { data, error, isLoading }] = useIdentifyTaxMutation();
  const [taxStatus, setTaxStatus] = useState();
  const stripePromise = loadStripe(
    process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY
  );
  let authtoken = localStorage.getItem("authToken");
  const apiUrl = process.env.REACT_APP_API_URL;

  // const editEventIfo = useSelector((state) => state.stripeFee.status);
  const [bookEvent] = useBookEventMutation();
  const { data: profileData } = useGetProfileInformationQuery();
  const onBoarding = profileData?.user?.onBoarding;
  // Function to get current date and time
  const getCurrentDateTime = () => {
    const now = new Date();
    const date = now.toISOString().split("T")[0]; // YYYY-MM-DD format
    const time = now.toTimeString().split(" ")[0]; // HH:MM:SS format
    return { date, time };
  };
  const firstTicket = Object.entries(ticketSummary)[0]; // Get the first ticket entry
  const [ticketType, ticketDetails] = firstTicket || [];
  useEffect(() => {
    if (ticketSummary) {
      const initialQuantities = Object.keys(ticketSummary).reduce(
        (acc, typeName) => {
          acc[typeName] = 0; // Initialize all quantities to 0
          return acc;
        },
        {}
      );
      setQuantities(initialQuantities);
    }
  }, [ticketSummary]);

  const handleQuantityChange = (typeName, change) => {
    setQuantities((prev) => {
      const currentQuantity = prev[typeName] || 0;
      const maxQuantity = ticketSummary[typeName]?.quantity || 0;
      const newQuantity = Math.min(
        Math.max(currentQuantity + change, 0),
        maxQuantity
      );
      return { ...prev, [typeName]: newQuantity };
    });
  };

  // Calculate subtotal
  const subtotal = Object.entries(quantities).reduce(
    (total, [typeName, quantity]) => {
      const price = ticketSummary[typeName]?.price || 0;
      return total + quantity * price;
    },
    0
  );

  const [cardDetails, setCardDetails] = useState({
    name: "John Henry",
    number: "**** **** **** 3947",
    expMonth: "12",
    expYear: "2024",
    cvc: "123",
  });

  const [selectedPayment, setSelectedPayment] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCardDetails((prevState) => ({ ...prevState, [name]: value }));
  };

  const handlePaymentSelect = (paymentMethod) => {
    setSelectedPayment(paymentMethod);
  };

  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  // Prepare payload
  const preparePayload = () => {
    const { date, time } = getCurrentDateTime();
    const organizerWithRoleId1 = event.eventOrganizers.find(
      (organizer) => organizer.roleId === 1
    );
    // Extract the userId if an organizer with roleId 1 was found
    const userIdWithRoleId1 = organizerWithRoleId1
      ? organizerWithRoleId1.userId
      : null;
    const createdBy = userIdWithRoleId1;
    const ticketTypes = Object.keys(ticketSummary).map((key) => {
      const quantity = quantities[key] || 0;
      const unitPrice = ticketSummary[key]?.price || 0;
      const totalPrice = quantity * unitPrice;

      return {
        type: key.toUpperCase(),
        quantity,
        totalPrice
      };
    });

    return {
      eventId: event?.eventId.toString(),
      ticketTypes,
      date,
      time,
      totalPrice: subtotal,
      createdBy,
      invitationId,
    };
  };
  const payloadTax = { eventId: event?.eventId };
  const payload = preparePayload();
  useEffect(() => {
    setTaxStatus(event?.tax);
  }, [event?.eventId, identifyTax]);
  const handleBookEventClick = async () => {
    // console.log(quantities);
    const allZero = Object.values(quantities).every(
      (quantity) => quantity === 0
    );
    if (allZero) {
      notification.warning({
        message: "Please select at least one ticket type!", // Warning message
      });
      return;
    }
    // Call the bookEvent API
    try {
      const bookingResponse = await bookEvent(payload).unwrap();
      // console.log("Payment successful and event booked!", bookingResponse);
      notification.success({
        message: "Event booked successfully!", // Success message
      });
      navigate("/ticket-invoice", {
        state: { incomingEvent: event, ticketSummary, bookingResponse },
      });
    } catch (error) {
      notification.error({
        message: error.data?.message || "Failed to book the event!", // Error message
      });
    }
  };

  return (
    <Grid container p={1}>
      <Paper
        elevation={1}
        sx={{
          padding: 3,
          width: "100%",
          height: { xl: "90vh", lg: "90", md: "90", xs: "100%" },
        }}
      >
        <Grid
          container
          spacing={3}
          sx={{ ...(subtotal === 0 && { flexDirection: "column" }) }}
        >
          <Grid item xs={12} md={6}>
            <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
              <IconButton size="small" onClick={handleGoBack}>
                <PaymentBackIcon />
              </IconButton>
              <Typography variant="h6">Book Tickets</Typography>
            </Box>
            <Typography variant="subtitle1" gutterBottom>
              Tickets
            </Typography>
            {Object.entries(ticketSummary)
              .filter(([_, { quantity }]) => quantity > 0)
              .map(([typeName, { price, quantity }]) => (
                <Box
                  key={typeName}
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  mb={1}
                >
                  <Typography sx={{ fontWeight: "bold" }}>
                    {typeName.charAt(0).toUpperCase() + typeName.slice(1)}{" "}
                    Ticket
                  </Typography>
                  <Box display="flex" alignItems="center">
                    <IconButton
                      onClick={() => handleQuantityChange(typeName, -1)}
                      disabled={quantities[typeName] <= 0}
                    >
                      <MinusIcon />
                    </IconButton>
                    <Typography sx={{ fontWeight: "bold", mx: 1 }}>
                      {quantities[typeName]}
                    </Typography>
                    <IconButton
                      onClick={() => handleQuantityChange(typeName, 1)}
                      disabled={quantities[typeName] >= quantity}
                    >
                      <PlusIcon />
                    </IconButton>
                  </Box>
                </Box>
              ))}
            <Divider />

            {/* <Divider />
            <Box justifyContent="space-between" alignItems="center" my={1}>
              <Typography>Amount</Typography>
              <Typography sx={{ fontWeight: "bold" }}>${subtotal}</Typography>
            </Box> */}
            <Divider />

            {/* {taxStatus && (
              <>
                <Divider />
                <Box justifyContent="space-between" alignItems="center" my={1}>
                  <Typography>Process fee</Typography>
                  <Typography sx={{ fontWeight: "bold" }}>
                    {taxStatus ? "3.5%" : "0%"}
                  </Typography>
                </Box>
                <Divider />
              </>
            )} */}

            <Divider />
            <Box justifyContent="space-between" alignItems="center" my={1}>
              <Typography>Total Amount</Typography>
              <Typography sx={{ fontWeight: "bold" }}>
                ${!taxStatus ? subtotal : subtotal + subtotal * 0.035}
              </Typography>
            </Box>
            <Divider />
          </Grid>
          {subtotal === 0 ? (
            <Box sx={{ marginTop: "2rem", marginLeft: "1.4rem" }}>
              <Box>
                <Button
                  sx={{
                    color: "#061F44",
                    backgroundColor: "#dadada",
                    fontSize: "16px",
                    fontWeight: 700,
                  }}
                  onClick={handleBookEventClick}
                >
                  Buy
                </Button>
              </Box>
            </Box>
          ) : (
            <Elements stripe={stripePromise}>
              <PaymentForm
                payload={payload}
                subtotal={!taxStatus ? subtotal : subtotal + subtotal * 0.035}
                event={event}
                ticketSummary={ticketSummary}
                canPay={onBoarding === true}
              />
            </Elements>
          )}
        </Grid>
      </Paper>
    </Grid>
  );
};

export default TicketBooking;
